export const SET_SELECTED_TSO = "SET_SELECTED_TSO";
export const SET_SELECTED_TSOS = "SET_SELECTED_TSOS";

export const SetSelectedTso = (tso: string) => {
    return { type: SET_SELECTED_TSO, tso };
};
export const SetSelectedTsos = (tsos: string[]) => {
    return { type: SET_SELECTED_TSOS, tsos };
};
